import { EuphaWorldContainer, AnimatedComponent } from '../styles/Layout.style'
import EuphaWorldHeader from "../components/EuphaWorldHeader/EuphaWorldHeader"
import BlogSlider from "../components/BlogSlider/BlogSlider"
import EuphaEvents from "../components/EuphaEvents/EuphaEvents"
import { ContentContainerEuphaWorld, TitleEuphaWorld, ButtonMore } from '../styles/Layout.style'
import PhotoSlider from '../components/PhotoSlider/PhotoSlider'

const EuhpaWorld = () => {
    return (
      <EuphaWorldContainer>
        <EuphaWorldHeader />
        <ContentContainerEuphaWorld>
          <TitleEuphaWorld>
            <p><span>Medicina</span> Integrativa</p>
            <p>...</p>
            <p>Entérate de las últimas noticias que EUPHA Pharma tiene para ti.</p>
          </TitleEuphaWorld>
          <AnimatedComponent>
            <BlogSlider />
          </AnimatedComponent>
          <AnimatedComponent>
            <EuphaEvents />
          </AnimatedComponent>
          <AnimatedComponent>
            <PhotoSlider />
          </AnimatedComponent>
          <ButtonMore>
            <button>Descubre más</button>
          </ButtonMore>
        </ContentContainerEuphaWorld>
      </EuphaWorldContainer>
    )
}

export default EuhpaWorld
